import moment from 'moment/moment'

export default function dateTimeCurrent() {
  return moment().format()
}



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/dateTimeCurrent.js